// extracted by mini-css-extract-plugin
export var aniSpin = "m_d";
export var inner = "m_r";
export var player = "m_s";